import { AppState } from '../../../redux/initialStates/AppState';
import { IOrderSmsMessages } from '../initialStates/orderSMSMessagesInitialState';

export const orderSmsMessagesSelector = (state: AppState): IOrderSmsMessages => state.orderSmsMessages;
